import { createSlice } from "@reduxjs/toolkit"

export interface LoadingState {
    isLoading: boolean
}

const initialState: LoadingState = {
    isLoading: false,
}

export const loadingSlice = createSlice({
    name: "loading",
    initialState,
    reducers: {
        showLoading: (state: LoadingState) => {
            state.isLoading = true
        },
        hideLoading: (state: LoadingState) => {
            state.isLoading = false
        },
        toggleLoading: (state: LoadingState) => {
            state.isLoading = !state.isLoading
        },
    },
})

// Action creators are generated for each case reducer function
export const { showLoading, hideLoading, toggleLoading } = loadingSlice.actions

export default loadingSlice.reducer
